import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";
import { CloseIcon } from "../SvgIcons/CloseIcon";
import Slide from "@material-ui/core/Slide";
import { Box, Grid } from "@material-ui/core";
import clsx from "clsx";
import { setAllowScrolling } from "playbook-pwa-ui";
import { QAppBar } from "../QAppBar";

const useStyles = makeStyles(() => ({
  closeButton: {
    position: "fixed",
    right: "0",
    top: "10px",
    right: "10px",
    zIndex: "999",
  },
  inheritHeight: {
    height: "100vh",
    overflow: "scroll",
  },
}));

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

export function QDialog({ onCancel, open, children, alt }) {
  const classes = useStyles();

  React.useEffect(() => {
    setAllowScrolling(!open);
  }, [open]);

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onCancel}
      TransitionComponent={Transition}
    >
      {alt ? (
        <QAppBar closeHandler={onCancel} text={alt} />
      ) : (
        <IconButton
          className={classes.closeButton}
          color="inherit"
          onClick={onCancel}
          aria-label="close"
        >
          <CloseIcon fontSize="large" />
        </IconButton>
      )}

      <Grid
        container
        justifyContent="center"
        alignItems="center"
        className={clsx(classes.inheritHeight)}
      >
        <Grid item>
          <Box>{children}</Box>
        </Grid>
      </Grid>
    </Dialog>
  );
}
